import { useApiRemove } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornData } from '../../../../../application/business';

export const useEditionAssetRemove = () => useApiRemove<StubbornData>(PATH);
